import CopyLink from './CopyLink';

export default CopyLink;
